"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.softChopMiddleware = void 0;
var _video = _interopRequireDefault(require("video.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable import/prefer-default-export */

// This middleware relies on startTime and endTime on the player options object
// They represent the adjusted start and end time of the video and is
// primarily used to create the appearance of a duration that
// matches the actual event duration and what the audience saw WN-5268
var softChopMiddleware = exports.softChopMiddleware = function softChopMiddleware(player) {
  var tech;
  player.on('play', function () {
    tech.trigger('durationchange');
  });
  var createNewRanges = function createNewRanges(timeRanges, start) {
    var newRanges = [];

    // adjust buffer ranges accordingly
    for (var i = 0; i < timeRanges.length; i += 1) {
      newRanges.push([Math.max(0, timeRanges.start(i) - start), Math.min(Math.max(0, timeRanges.end(i) - start), player.duration())]);
    }
    return _video["default"].time.createTimeRanges(newRanges);
  };
  var _player$options = player.options(),
    _player$options$custo = _player$options.customPlayerTime,
    _player$options$custo2 = _player$options$custo === void 0 ? {} : _player$options$custo,
    _player$options$custo3 = _player$options$custo2.startTime,
    startTime = _player$options$custo3 === void 0 ? 0 : _player$options$custo3,
    _player$options$custo4 = _player$options$custo2.endTime,
    endTime = _player$options$custo4 === void 0 ? 0 : _player$options$custo4;
  return {
    setTech: function setTech(newTech) {
      tech = newTech;
    },
    currentTime: function currentTime(ct) {
      // need to rewind video if it reaches end
      if (endTime) {
        if (ct > endTime) {
          player.currentTime(0);
          player.pause();
          tech.trigger('timeupdate');
          return 0;
        }
      }
      // if startTime exists, adjust currentTime
      if (startTime) {
        if (ct - startTime >= 0) {
          return ct - startTime;
        }
      }
      return ct;
    },
    setCurrentTime: function setCurrentTime(ct) {
      // if startTime exists, adjust seek to time
      if (startTime !== undefined) {
        return ct + startTime;
      }
      return ct;
    },
    duration: function duration(dur) {
      // adjust duration for custom times
      // we need to account for the scenario where the endTime
      // is greater than the duration of the video..
      if (endTime > dur) {
        return Math.round(dur);
      }
      if (endTime > 0 && endTime > startTime) {
        return Math.round(endTime - startTime);
      }
      return Math.round(dur);
    },
    buffered: function buffered(bf) {
      return createNewRanges(bf, startTime);
    },
    seekable: function seekable(_seekable) {
      return createNewRanges(_seekable, startTime);
    },
    played: function played(_played) {
      return createNewRanges(_played, startTime);
    }
  };
};
softChopMiddleware.VERSION = '1.0.0';